// Common

export const SIMULATION_SPEED = 200;
export const MAX_SHADOW_CASTERS = 7;

// POST PROCESSING
export const BLOOM_THRESHOLD = 0.55;
export const BLOOM_STRENGTH = 0.28;
export const BLOOM_RADIUS = 0.2;
